(function () {
  'use strict';

  var transition = document.querySelector('[data-veyr-page-transition]');
  if (!transition || document.body.dataset.veyrPageTransitionBound === 'true') return;

  document.body.dataset.veyrPageTransitionBound = 'true';
  document.documentElement.classList.add('veyr-page-transition-js');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var leaving = false;
  var navigationTimer = 0;
  var revealFrameOne = 0;
  var revealFrameTwo = 0;
  var navigationDelay = 240;

  function clearRevealFrames() {
    if (revealFrameOne) window.cancelAnimationFrame(revealFrameOne);
    if (revealFrameTwo) window.cancelAnimationFrame(revealFrameTwo);
    revealFrameOne = 0;
    revealFrameTwo = 0;
  }

  function clearNavigationTimer() {
    if (navigationTimer) {
      window.clearTimeout(navigationTimer);
      navigationTimer = 0;
    }
  }

  function skipNativeTransition(event) {
    if (!event || !event.viewTransition || typeof event.viewTransition.skipTransition !== 'function') return;
    try {
      event.viewTransition.skipTransition();
    } catch (error) {
      // The custom loader still owns the transition when native skipping is unavailable.
    }
  }

  function revealPage() {
    clearNavigationTimer();
    clearRevealFrames();
    leaving = false;
    document.body.classList.remove('veyr-page-leaving');

    revealFrameOne = window.requestAnimationFrame(function () {
      revealFrameOne = 0;
      revealFrameTwo = window.requestAnimationFrame(function () {
        revealFrameTwo = 0;
        document.body.classList.add('veyr-page-ready');
      });
    });
  }

  function destinationFor(anchor) {
    if (!anchor || anchor.target || anchor.hasAttribute('download')) return null;
    if (anchor.closest('[data-no-veyr-transition]')) return null;

    var href = anchor.getAttribute('href');
    if (!href || href.indexOf('#') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return null;

    var destination;
    try {
      destination = new URL(anchor.href, window.location.href);
    } catch (error) {
      return null;
    }

    if (destination.origin !== window.location.origin) return null;
    if (destination.pathname === window.location.pathname && destination.search === window.location.search) return null;
    return destination;
  }

  function beginNavigation(event, destination, stopOtherHandlers) {
    if (leaving || !destination) return;

    event.preventDefault();
    if (stopOtherHandlers) event.stopImmediatePropagation();

    leaving = true;
    document.body.classList.add('veyr-page-leaving');
    document.body.classList.remove('veyr-page-ready');

    clearNavigationTimer();
    navigationTimer = window.setTimeout(function () {
      navigationTimer = 0;
      try {
        window.location.assign(destination.href);
      } catch (error) {
        leaving = false;
        document.body.classList.remove('veyr-page-leaving');
        document.body.classList.add('veyr-page-ready');
      }
    }, navigationDelay);
  }

  function shouldIgnoreClick(event) {
    return (
      leaving ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function clickElement(event) {
    if (event.target instanceof Element) return event.target;
    return event.target && event.target.parentElement ? event.target.parentElement : null;
  }

  function handleProductCardClick(event) {
    if (shouldIgnoreClick(event)) return;

    var target = clickElement(event);
    var productCard = target && target.closest('product-card');
    if (!productCard) return;

    var anchor = target.closest('a[href]');
    if (!anchor) {
      if (target.closest('button, input, select, textarea, label, summary, [role="button"], [contenteditable="true"], [data-no-veyr-transition]')) return;
      anchor = productCard.querySelector('a.product-card__link[href], a[href*="/products/"]');
    }

    beginNavigation(event, destinationFor(anchor), true);
  }

  function handleAnchorClick(event) {
    if (shouldIgnoreClick(event)) return;

    var target = clickElement(event);
    if (!target || target.closest('product-card')) return;

    var anchor = target.closest('a[href]');
    beginNavigation(event, destinationFor(anchor), false);
  }

  revealPage();
  window.addEventListener('pageshow', revealPage);
  window.addEventListener('pagehide', function () {
    clearNavigationTimer();
    clearRevealFrames();
  });
  window.addEventListener('pageswap', skipNativeTransition);
  window.addEventListener('pagereveal', skipNativeTransition);

  if (reduceMotion) return;

  document.addEventListener('click', handleProductCardClick, true);
  document.addEventListener('click', handleAnchorClick);
})();
